<template lang="pug">
  Modal(ref="modal" title="Response Message" closable="true")
    .vaidation-message-modal-body.ssp-form-horizontal
      .center
        p(v-if="validationMessage !== ''") {{validationMessage}}
        em.text-muted(v-else) No validation message set

    div(slot="footer")
      button.btn.btn-default(@click="$refs.modal.cancel()") Close
</template>

<script>
import Modal from '@/components/common/Modal'

export default {
  data() {
    return {
      validationMessage: null
    }
  },
  methods: {
    open(validationMessage) {
      this.validationMessage = validationMessage
      this.$refs.modal.open()
    }
  },
  components: {
    Modal
  }
}
</script>
<style lang="scss">
.vaidation-message-modal-body {
  min-width: 300px;
  max-width: 600px;
  min-height: 50px;

  .center {
    text-align: center;
    padding-top: 25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/core/validation/validationlog/ValidationMessageModal.vue